import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './pdf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Triangular distribution probability density function (PDF).
*
* @module @stdlib/stats/base/dists/triangular/pdf
*
* @example
* var pdf = require( '@stdlib/stats/base/dists/triangular/pdf' );
*
* var y = pdf( 0.5, -1.0, 1.0, 0.0 );
* // returns 0.5
*
* y = pdf( 0.5, -1.0, 1.0, 0.5 );
* // returns 1.0
*
* y = pdf( -10.0, -20.0, 0.0, -2.0 );
* // returns ~0.056
*
* var mypdf = pdf.factory( 0.0, 10.0, 5.0 );
* y = mypdf( 2.0 );
* // returns 0.08
*
* y = mypdf( 12.0 );
* // returns 0.0
*/

// MODULES //
var setReadOnly = __var_0__;
var pdf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( pdf, 'factory', factory );


// EXPORTS //
export default pdf;
